const TRACKING_USER_ID_KEY = 'ga_user_id';

const textEncoder = new TextEncoder();

function bufferToHex(buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer);
    let hex = '';
    for (let i = 0; i < bytes.length; i++) hex += bytes[i].toString(16).padStart(2, '0');
    return hex;
}
export async function hashUserId(id: string): Promise<string> {
    const digest = await crypto.subtle.digest('SHA-256', textEncoder.encode(id));
    return bufferToHex(digest);
}
let currentUserId: string | null = null;
export function getUserId(): string | null {
    return currentUserId;
}

export function clearUserId(): void {
    currentUserId = null;
    try { localStorage.removeItem(TRACKING_USER_ID_KEY); } catch {}
}

export function initUserIdFromStorage(): void {
    try {
        const stored = localStorage.getItem(TRACKING_USER_ID_KEY);
        currentUserId = stored ?? null;
    } catch {
        currentUserId = null;
    }
}

export async function setUserIdFromInternalId(id: string | null): Promise<void> {
    if (id == null) {
        clearUserId();
        return;
    }
    const hashed = await hashUserId(id);
    currentUserId = hashed;
    try { localStorage.setItem(TRACKING_USER_ID_KEY, hashed); } catch {}
}
